(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cargador-3en1"] && !Shopify.designMode) return;
  try {
    
function setupCarrier(scope){scope.querySelectorAll('.cb').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-cb-image]').forEach(button=>button.addEventListener('click',()=>{const image=root.querySelector('.cb-main-image');if(!image)return;image.removeAttribute('srcset');image.src=button.dataset.cbImage;root.querySelectorAll('[data-cb-image]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));}));root.querySelectorAll('[data-cb-money]').forEach(input=>input.addEventListener('change',()=>{const id=root.querySelector('[data-cb-variant]');id.value=input.value;id.dispatchEvent(new Event('change',{bubbles:true}));root.querySelectorAll('[data-cb-price]').forEach(el=>el.textContent=input.dataset.cbMoney);const image=root.querySelector('.cb-main-image');if(image&&input.dataset.cbVariantImage){image.removeAttribute('srcset');image.src=input.dataset.cbVariantImage;root.querySelectorAll('[data-cb-image]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.cbImage===input.dataset.cbVariantImage)));}const url=new URL(window.location.href);url.searchParams.set('variant',input.value);window.history.replaceState({},'',url);}));});}setupCarrier(document);document.addEventListener('shopify:section:load',event=>setupCarrier(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumifest-landing"] && !Shopify.designMode) return;
  try {
    
function initializeLumiFest(scope) {
  scope.querySelectorAll('.lf').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const mainImage = root.querySelector('.lf-featured');
    const mainButton = root.querySelector('[data-lf-open]');
    const thumbs = Array.from(root.querySelectorAll('.lf-thumb'));
    const caption = root.querySelector('[data-lf-caption]');
    const count = root.querySelector('[data-lf-count]');
    const dialog = root.querySelector('.lf-lightbox');
    let active = 0;
    const showImage = (src, alt, fit) => {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
      mainImage.alt = alt || '';
      mainButton.dataset.fit = fit || 'contain';
    };
    const selectImage = index => {
      if (!thumbs.length) return;
      active = (index + thumbs.length) % thumbs.length;
      const button = thumbs[active];
      showImage(button.dataset.src, button.dataset.alt, button.dataset.fit);
      thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      if (caption) caption.textContent = button.dataset.alt;
      if (count) count.textContent = `${active + 1} / ${thumbs.length}`;
    };
    thumbs.forEach((button, index) => button.addEventListener('click', () => selectImage(index)));
    root.querySelector('[data-lf-previous]')?.addEventListener('click', () => selectImage(active - 1));
    root.querySelector('[data-lf-next]')?.addEventListener('click', () => selectImage(active + 1));
    root.querySelector('.lf-gallery')?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        selectImage(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    mainButton?.addEventListener('click', () => {
      if (!dialog || !mainImage) return;
      const enlarged = dialog.querySelector('img');
      enlarged.src = mainImage.currentSrc || mainImage.src;
      enlarged.alt = mainImage.alt;
      dialog.showModal();
    });
    root.querySelector('[data-lf-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    if (thumbs.length) {
      thumbs[0].setAttribute('aria-pressed', 'true');
      if (count) count.textContent = `1 / ${thumbs.length}`;
    }
    root.querySelectorAll('.lf-radio').forEach(radio => radio.addEventListener('change', () => {
      const variantInput = root.querySelector('[data-lf-variant-id]');
      variantInput.value = radio.value;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      root.querySelectorAll('[data-price]:not(input)').forEach(price => price.textContent = radio.dataset.price);
      const compare = root.querySelector('[data-compare]:not(input)');
      if (compare) { compare.textContent = radio.dataset.compare; compare.hidden = radio.dataset.sale !== 'true'; }
      if (radio.dataset.image) showImage(radio.dataset.image, radio.nextElementSibling.textContent.trim());
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url);
    }));
  });
}
initializeLumiFest(document);
document.addEventListener('shopify:section:load', event => initializeLumiFest(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumifest-shipping-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lf-shipping-banner')) {
  customElements.define('lf-shipping-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const toggle = this.querySelector('.lf-shipping-toggle');
      toggle.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? toggle.dataset.resume : toggle.dataset.pause);
        toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nidobaby-landing"] && !Shopify.designMode) return;
  try {
    
function initializeNido(scope) {
  scope.querySelectorAll('.nb').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const image = root.querySelector('.nb-main');
    root.querySelectorAll('[data-nb-src]').forEach(button => button.addEventListener('click', () => {
      if (!image) return;
      image.removeAttribute('srcset');
      image.src = button.dataset.nbSrc;
      root.querySelectorAll('[data-nb-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    root.querySelectorAll('.nb-radio').forEach(radio => radio.addEventListener('change', () => {
      const field = root.querySelector('[data-nb-id]');
      field.value = radio.value;
      field.dispatchEvent(new Event('change', {bubbles:true}));
      root.querySelectorAll('[data-nb-price]').forEach(price => price.textContent = radio.dataset.nbMoney);
      const url = new URL(window.location.href);
      url.searchParams.set('variant',radio.value);
      window.history.replaceState({},'',url);
    }));
  });
}
initializeNido(document);
document.addEventListener('shopify:section:load',event => initializeNido(event.target));

  } catch(e) { console.error(e); }
})();
})();
